export default {
  about: '/klinische-psychologie-trifft-virtual-reality',
  contact: '/contact',
  product: '/verhaltenstherapie-interaktiv-und-virtuell',
  science: '/wie-virtual-reality-therapeutisch-wirkt',
  therapy: '/angstbehandlung-und-exposition-mit-vr-therapie',
  landing: '/landing'
}
